var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.CoolLightBox,{attrs:{"items":_vm.items,"index":_vm.index,"translations":_setup.translations,"slideshow":false},on:{"close":function($event){return _vm.$emit('box-close')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }